import { render, staticRenderFns } from "./EditAreaForm.vue?vue&type=template&id=3dae6c82&scoped=true"
import script from "./EditAreaForm.vue?vue&type=script&lang=js"
export * from "./EditAreaForm.vue?vue&type=script&lang=js"
import style0 from "./EditAreaForm.vue?vue&type=style&index=0&id=3dae6c82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dae6c82",
  null
  
)

export default component.exports